/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Redo_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Redo" |
*
* @param {Toolbar_Secondary_Redo_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_redo_aria_label = /** @type {((inputs?: Toolbar_Secondary_Redo_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Redo_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rétablir")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederholen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rifare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переделать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rehacer")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重做")
	if (locale === "ja") return /** @type {LocalizedString} */ ("やり直す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फिर से करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Refazer")
	return /** @type {LocalizedString} */ ("Redo")
});